// extracted by mini-css-extract-plugin
export default {"container":"uD-z","dimension":"vD-z","dimensionLabels":"wD-z"};